<template>
  <div class='home'>
    <PaymentTypeList
      v-show='listView'
      @newPaymentType='onClickNewFromList'
      @editPaymentType='onClickEditFromList'
      :scroll="corY" ref='refreshList'
    />
    <PaymentTypeForm
      v-show='formView'
      :paymentType='paymentType'
      @backClicked='onBackChild'
    />
  </div>
</template>

<script>
// @ is an alias to /src
import PaymentTypeList from '@/components/payment-type/PaymentTypeList.vue'
import PaymentTypeForm from '@/components/payment-type/PaymentTypeForm.vue'

export default {
  name: 'Payment_Type',
  components: {
    PaymentTypeList,
    PaymentTypeForm
  },
  data () {
    return {
      corX: 0,
      corY: 0,
      listView: true,
      formView: false,
      paymentType: {
        id: null,
        name: null
      }
    }
  },
  methods: {
    onClickEditFromList: function (value) {
      var x = window.pageXOffset
      var y = window.pageYOffset
      this.corX = x
      this.corY = y
      window.scrollTo(0, 0)
      this.listView = false
      this.formView = true
      console.log(value)
      this.paymentType = value
    },
    onClickNewFromList: function () {
      var x = window.pageXOffset
      var y = window.pageYOffset
      this.corX = x
      this.corY = y
      window.scrollTo(0, 0)
      this.listView = false
      this.formView = true
      this.paymentType = {
        id: null,
        name: null
      }
    },
    async onBackChild () {
      window.scrollTo(this.corX, this.corY)
      this.listView = true
      this.formView = false
      this.paymentType = {
        id: null,
        name: null
      }
      await this.$refs.refreshList.refreshList()
      await window.scrollTo(this.corX, this.corY)
      console.log('window.scrollTo:' + this.corY)
    }
  },
  mounted () {}
}
</script>
